<template>
  <div>
    <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    />
    <div class="pages">
      <div class="headerTop">
        <div class="headerTop-ConItem" @click="nationshow = true">
          <div class="headerTop-title">民族</div>
          <div class="headerTop-icon">
            <div class="headerTop-text">{{ userInfo.nation }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="headerTop-ConItem" @click="birthdayshow = true">
          <div class="headerTop-title">生日</div>
          <div class="headerTop-icon">
            <div class="headerTop-text">{{ userInfo.birthday }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="headerTop-ConItem" @click="gendershow = true">
          <div class="headerTop-title">性别</div>
          <div class="headerTop-icon">
            <div class="headerTop-text">{{ userInfo.gender }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="headerTop-ConItem" @click="heightshow = true">
          <div class="headerTop-title">身高</div>
          <div class="headerTop-icon">
            <div class="headerTop-text">{{ userInfo.height }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="headerTop-ConItem" @click="weightshow = true">
          <div class="headerTop-title">体重</div>
          <div class="headerTop-icon">
            <div class="headerTop-text">{{ userInfo.weight }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="headerTop-ConItem" @click="laborshow = true">
          <div class="headerTop-title">劳动强度</div>
          <div class="headerTop-icon">
            <div class="headerTop-text">{{ labourIntensity.flagName }}</div>
            <van-icon name="arrow" />
          </div>
        </div>
        <div>
          <div class="headerTop-ConItem">
            <div class="headerTop-title">疾病</div>
          </div>
          <div class="headerTop-List">
            <div
              v-for="(item, index) in diseaseList"
              :key="index"
              @click="diseaseChange(item, index)"
            >
              <div
                :class="
                  item.istrue
                    ? 'headerTop-List-diseaseIs'
                    : 'headerTop-List-disease'
                "
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="true">
          <div class="headerTop-ConItem">
            <div class="headerTop-title">过敏源</div>
          </div>
          <div class="headerTop-List">
            <div
              v-for="(item, index) in AllergenList"
              :key="index"
              @click="AllergenChange(item, index)"
            >
              <div
                :class="
                  item.istrue
                    ? 'headerTop-List-diseaseIs'
                    : 'headerTop-List-disease'
                "
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="preservation" @click="changePreservation">保 存</div>

      <van-action-sheet v-model="nationshow">
        <div class="sheetTitle">
          {{ "民族" }}
        </div>
        <van-picker
          :columns="nationcolumns"
          value-key="label"
          :value="nationcolumns.value"
          :swipe-duration="200"
          @change="funnation"
        />
        <div class="btnS">
          <div class="btnS-close" @click="nationshow = false">取消</div>
          <div class="btnS-open" @click="nationChange">确认</div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="birthdayshow">
        <div class="sheetTitle">
          {{ "生日" }}
        </div>
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :swipe-duration="200"
          :show-toolbar="false"
          :min-date="minDate"
          :max-date="maxDate"
        />
        <div class="btnS">
          <div class="btnS-close" @click="birthdayshow = false">取消</div>
          <div class="btnS-open" @click="birthdayFun">确认</div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="gendershow">
        <div class="sheetTitle">
          {{ "性别" }}
        </div>
        <van-picker
          :columns="gendercolumns"
          @change="fungender"
          :swipe-duration="200"
          v-model="setUserInfo.gender"
        />
        <div class="btnS">
          <div class="btnS-close" @click="gendershow = false">取消</div>
          <div class="btnS-open" @click="genderChange">确认</div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="heightshow">
        <div class="sheetTitle">
          {{ "身高" }}
        </div>
        <van-picker
          :columns="heightcolumns"
          @change="funheight"
          :swipe-duration="200"
        />
        <div class="btnS">
          <div class="btnS-close" @click="heightshow = false">取消</div>
          <div class="btnS-open" @click="heightChange">确认</div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="weightshow">
        <div class="sheetTitle">
          {{ "体重" }}
        </div>
        <van-picker
          :columns="weightcolumns"
          @change="funweight"
          :swipe-duration="200"
        />
        <div class="btnS">
          <div class="btnS-close" @click="weightshow = false">取消</div>
          <div class="btnS-open" @click="weightChange">确认</div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="laborshow">
        <div class="sheetTitle">
          {{ "劳动强度" }}
        </div>
        <van-picker
          :columns="laborcolumns"
          @change="funlabor"
          value-key="name"
          :swipe-duration="200"
          :value="nationcolumns.value"
        />
        <div class="sheetText">
          {{ labortext }}
        </div>
        <div class="btnS">
          <div class="btnS-close" @click="laborshow = false">取消</div>
          <div class="btnS-open" @click="laborChange">确认</div>
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>
<script>
import {
  nationalityEnum,
  getAllCommonFlag,
  saveUserHealthyProfile,
  getUserHealthyProfile,
} from "@/apis/stems.js";
export default {
  data() {
    return {
      nationshow: false,
      nationcolumns: [],
      birthdayshow: false,
      minDate: new Date(1922, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      gendershow: false,
      gendercolumns: ["男", "女"],
      heightshow: false,
      heightcolumns: [],
      weightshow: false,
      weightcolumns: [],
      laborshow: false,
      laborcolumns: [],
      labortext: "",
      diseaseList: [],
      AllergenList: [],
      userInfo: {},
      labourIntensity: {},
      setUserInfo: {},
      islabor: false,
      diseaseChoiceMode: true,
      AllergenChoiceMode: true,
    };
  },
  mounted() {
    this.handInit();
    this.getUserHealthyProfileFun();
  },
  methods: {
    handInit() {
      nationalityEnum().then((res) => {
        this.nationcolumns = res.data.data;
      });
      getAllCommonFlag().then((res) => {
        const Arrdata = res.data.data;
        for (let i = 0; i < Arrdata.length; i++) {
          if (Arrdata[i].category == "user" && Arrdata[i].type == "workLevel") {
            this.laborcolumns.push(Arrdata[i]);
          } else if (
            Arrdata[i].category == "user" &&
            Arrdata[i].type == "disease"
          ) {
            Arrdata[i].istrue = false;
            this.diseaseList.push(Arrdata[i]);
            this.diseaseChoiceMode = Arrdata[i].choiceMode == 1 ? true : false;
          } else if (
            Arrdata[i].category == "user" &&
            Arrdata[i].type == "allergen"
          ) {
            Arrdata[i].istrue = false;
            this.AllergenList.push(Arrdata[i]);
            this.AllergenChoiceMode = Arrdata[i].choiceMode == 1 ? true : false;
          }
        }
        this.labortext ? "" : (this.labortext = this.laborcolumns[0].desc);
      });
      this.heightcolumns = [];
      this.weightcolumns = [];
      for (let i = 0; i < 151; i++) {
        this.heightcolumns.push(80 + i);
      }
      for (let i = 0; i < 181; i++) {
        this.weightcolumns.push(20 + i);
      }
    },
    getUserHealthyProfileFun() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: "加载中...",
      });
      getUserHealthyProfile({
        userCode: sessionStorage.getItem("customerId"),
      })
        .then((res) => {
          if (res.data.data != null) {
            this.userInfo = res.data.data;
            this.userInfo.gender = this.userInfo.gender == 0 ? "女" : "男";
            this.userInfo.weight = this.userInfo.weight / 1000;
            this.userInfo.workLevel == 0 ? (this.userInfo.workLevel = 1) : "";
          } else {
            this.userInfo = {};
          }
          this.$toast.clear(); // 关闭加载
          for (let i = 0; i < this.userInfo.flag.length; i++) {
            if (
              this.userInfo.flag[i].category == "user" &&
              this.userInfo.flag[i].type == "workLevel"
            ) {
              this.labourIntensity = this.userInfo.flag[i];
            }
          }
          for (let index = 0; index < this.diseaseList.length; index++) {
            for (let i = 0; i < this.userInfo.flag.length; i++) {
              if (
                this.diseaseList[index].name == this.userInfo.flag[i].flagName
              ) {
                this.diseaseList[index].istrue = true;
              }
            }
          }
          for (let index = 0; index < this.AllergenList.length; index++) {
            for (let i = 0; i < this.userInfo.flag.length; i++) {
              if (
                this.AllergenList[index].name == this.userInfo.flag[i].flagName
              ) {
                this.AllergenList[index].istrue = true;
              }
            }
          }
        })
        .catch((err) => {
          this.$toast.clear(); // 关闭加载
        });
    },
    changePreservation() {
      let obj = JSON.parse(JSON.stringify(this.userInfo));
      delete obj.nutrientsConfigs;
      obj.weight = obj.weight * 1000;
      obj.gender = obj.gender == "男" ? 1 : 0;
      obj.userCode = sessionStorage.getItem("customerId");
      obj.operatorUser = "001";
      obj.flag = [];
      obj.flag.push(this.labourIntensity);
      for (let i = 0; i < this.diseaseList.length; i++) {
        if (this.diseaseList[i].istrue) {
          let isobj = {
            flagCode: this.diseaseList[i].code,
            flagName: this.diseaseList[i].name,
            number: this.diseaseList[i].code,
            configCode: this.diseaseList[i].configCode,
          };
          obj.flag.push(isobj);
        }
      }
      for (let i = 0; i < this.AllergenList.length; i++) {
        if (this.AllergenList[i].istrue) {
          let isobj = {
            flagCode: this.AllergenList[i].code,
            flagName: this.AllergenList[i].name,
            number: this.AllergenList[i].code,
            configCode: this.AllergenList[i].configCode,
          };
          obj.flag.push(isobj);
        }
      }
      saveUserHealthyProfile(obj).then((res) => {
        this.$notify({ type: "success", message: "保存成功", duration: 1000 });
        // this.$router.push("/Me");
      });
    },

    funnation(picker, values) {
      this.setUserInfo.nation = values.label;
    },
    nationChange() {
      this.setUserInfo.nation
        ? (this.userInfo.nation = this.setUserInfo.nation)
        : (this.userInfo.nation = this.nationcolumns[0].label);
      this.nationshow = false;
    },
    birthdayFun() {
      this.userInfo.birthday = this.dayjs(this.currentDate).format(
        "YYYY-MM-DD"
      );
      this.birthdayshow = false;
    },
    fungender(picker, values) {
      this.setUserInfo.gender = values;
      console.log(this.setUserInfo.gender, 280);
    },
    genderChange() {
      this.setUserInfo.gender
        ? (this.userInfo.gender = this.setUserInfo.gender)
        : (this.userInfo.gender = this.gendercolumns[0]);
      this.gendershow = false;
    },
    funheight(picker, values) {
      this.setUserInfo.height = values;
    },
    heightChange() {
      this.setUserInfo.height
        ? (this.userInfo.height = this.setUserInfo.height)
        : (this.userInfo.height = this.heightcolumns[0]);
      this.heightshow = false;
    },
    funweight(picker, values) {
      this.setUserInfo.weight = values;
    },
    weightChange() {
      this.setUserInfo.weight
        ? (this.userInfo.weight = this.setUserInfo.weight)
        : (this.userInfo.weight = this.weightcolumns[0]);
      this.weightshow = false;
    },
    funlabor(picker, values, index) {
      this.islabor = true;
      this.labortext = this.laborcolumns[index].desc;
      let obj = {
        flagCode: this.laborcolumns[index].code,
        flagName: this.laborcolumns[index].name,
        number: this.laborcolumns[index].code,
        configCode: this.laborcolumns[index].configCode,
      };
      this.labourIntensity = obj;
    },
    laborChange() {
      if (this.islabor) {
        if (this.labourIntensity && this.labourIntensity.number) {
          this.labourIntensity = this.labourIntensity;
        }
      } else {
        let obj = {
          flagCode: this.laborcolumns[0].code,
          flagName: this.laborcolumns[0].name,
          number: this.laborcolumns[0].code,
          configCode: this.laborcolumns[0].configCode,
        };
        this.labourIntensity = obj;
      }

      this.laborshow = false;
    },
    diseaseChange(item, index) {
      if (this.diseaseChoiceMode) {
        for (let i = 0; i < this.diseaseList.length; i++) {
          this.diseaseList[i].istrue = false;
        }
      }
      this.diseaseList[index].istrue = !this.diseaseList[index].istrue;
    },
    AllergenChange(item, index) {
      if (this.AllergenChoiceMode) {
        for (let i = 0; i < this.AllergenList.length; i++) {
          this.AllergenList[i].istrue = false;
        }
      }
      this.AllergenList[index].istrue = !this.AllergenList[index].istrue;
    },
  },
};
</script>
<style scoped>
::v-deep .van-picker__frame {
  border-top: 1px solid rgb(210, 210, 210);
  border-bottom: 1px solid rgb(210, 210, 210);
  border-left: none;
  border-right: none;
}
</style>
<style lang="less" scoped>
.pages {
  background: #f7f8fa;
  margin-top: 25px;
}
.sheetTitle {
  width: 80px;
  height: 60px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 60px;
  color: rgba(0, 0, 0, 0.9);
}
.sheetText {
  font-size: 10px;
  font-weight: 400;
  color: #ffab09;
  line-height: 18px;
  width: 300px;
  margin: 0 auto;
}
.headerTop {
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
  background: #ffffff;
  position: relative;
  border-radius: 8px 8px 8px 8px;
  box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
  line-height: 58px;
  padding-bottom: 40px;
  &-ConItem {
    height: 55px;
    display: flex;
    justify-content: space-between;
    position: relative;
  }
  &-title {
    font-size: 17px;
    font-weight: 500;
    color: #202020;
  }
  &-icon {
    color: #c0c0c0;
    font-size: 22px;
  }
  &-text {
    width: 120px;
    position: absolute;
    font-size: 17px;
    font-weight: 400;
    color: #c0c0c0;
    line-height: 20px;
    right: 25px;
    top: 18px;
    text-align: right;
  }
  &-List {
    display: flex;
    flex-wrap: wrap;
    & > div {
      width: 33%;
      margin-bottom: 5px;
    }
    & > div > div {
      width: 97px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: 15px;
      font-weight: 400;
      box-shadow: 0px 2px 4px 1px rgba(32, 32, 32, 0.1);
      border-radius: 8px 8px 8px 8px;
    }
    &-disease {
      background: #f7f8fa;
      color: #606060;
      margin: 3px 0;
    }
    &-diseaseIs {
      background: #07c160;
      color: #fff;
      margin: 3px 0;
    }
  }
}
.headerTop > div {
  border-bottom: 1px solid #f7f8fa;
}
.headerTop > div:last-child {
  border: none;
}
.btnS {
  width: 240px;
  height: 70px;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  text-align: center;
  justify-content: space-between;
  & > div {
    width: 108px;
    height: 40px;
    line-height: 40px;
    font-size: 17px;
    font-weight: 500;
    border-radius: 4px 4px 4px 4px;
  }
  &-close {
    background: rgba(247, 247, 247, 0.9);
    color: #07c160;
  }
  &-open {
    background: #07c160;
    color: #fff;
  }
}
.preservation {
  width: 343px;
  height: 52px;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 17px;
  font-weight: 400;
  color: #ffffff;
  line-height: 52px;
  text-align: center;
  background: linear-gradient(134deg, #4bd891 0%, #05a856 100%);
  border-radius: 27px 27px 27px 27px;
}
</style>